import {
  audioManager,
  gsap
} from '@powerplay/core-minigames'
import { AudioNames } from '../types'
import { player } from '../entities/athlete/player'

/**
 * metody ktore pomahaju pri spustani zvukov
 */
export class AudioHelper {

  /** Pocet frameov, kolko chyba do zmenu zvuku audience po faule */
  private framesChangeAudienceAfterFoul = 0

  /** Pocet framoev, kolko chyba do prehratia komentatorov po zapichnuti ostepu do zeme */
  private framesPlayCommentatorJavelinOnGround = 0

  /** pomocne veci pre zvuky komentatorov */
  private isBestAttempt = false
  private bestAttempt = 0
  private actualAttempt = 0

  /**
   * Zastavenie zvuku s delayom
   * @param name - Meno zvuku
   * @param delay - Delay pre zastavenie zvuku
   */
  public stopAudioWithDelay(name: AudioNames, delay = 0.5): void {

    gsap.to(
      {},
      {
        duration: delay,
        onComplete: () => {

          audioManager.stopAudioByName(name)

        }
      }
    )

  }

  /**
   * Nastavenie timera pre zmenu zvukov audience po faule
   */
  public setTimerToChangeAudienceAfterFoul(): void {

    this.framesChangeAudienceAfterFoul = 10

  }

  /**
   * Nastavenie timera pre prehratie zvukov po zapichnuti ostepu do zeme
   * @param isBestAttempt - Ci ide o najlepsi pokus
   * @param isBestAttempt - Hodnota najlepsieho pokusu
   * @param actualAttempt - Hodnota aktualneho pokusu
   */
  public setTimerToPlayCommentatorJavelinOnGround(
    isBestAttempt: boolean,
    bestAttempt: number,
    actualAttempt: number
  ): void {

    this.framesPlayCommentatorJavelinOnGround = 10
    this.isBestAttempt = isBestAttempt
    this.bestAttempt = bestAttempt
    this.actualAttempt = actualAttempt

  }

  /**
   * pustime movemement audio
   * @param audioNumber - cislo zvuku krokov
   */
  public playMovementAudio(audioNumber: number): void {

    audioManager.play(AudioNames.footstepPlayer + audioNumber)

  }

  /**
   * Kontrola, ci netreba prepnut divakov po X frameoch po faule
   */
  private checkChangeAudienceAfterFoul(): void {

    if (this.framesChangeAudienceAfterFoul === 0) return

    this.framesChangeAudienceAfterFoul -= 1

    if (this.framesChangeAudienceAfterFoul === 0) {

      audioHelper.stopAudioWithDelay(AudioNames.audienceCheering)
      audioManager.play(AudioNames.audienceIntroNoise)
      audioManager.play(AudioNames.audienceFoul)

    }

  }

  /**
   * Kontrola, ci netreba zapnut zvuky po zapichnuti ostepu do zeme
   */
  private checkPlayCommentatorJavelinOnGround(): void {

    if (this.framesPlayCommentatorJavelinOnGround === 0) return

    this.framesPlayCommentatorJavelinOnGround -= 1

    if (this.framesPlayCommentatorJavelinOnGround === 0) {

      player.javelin.playCommentatorAudioOnGround(this.isBestAttempt, this.bestAttempt, this.actualAttempt)

    }

  }

  /**
   * Aktualizacia kazdy frame, ak nieco treba
   */
  public update(): void {

    this.checkChangeAudienceAfterFoul()
    this.checkPlayCommentatorJavelinOnGround()

  }

  /**
   * Resetovanie veci
   */
  public reset(): void {

    this.framesChangeAudienceAfterFoul = 0

  }

}

export const audioHelper = new AudioHelper()
